exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggleNews[data-v-f7bd0c44]{right:95px;bottom:10px;width:auto;font-size:15px;color:#958d8d}.wrapper[data-v-f7bd0c44]{height:668.6px}.widget--border-box.single-cat .posts-wrap li[data-v-f7bd0c44]{margin-bottom:5px}.ad-300-250-sidebar-above[data-v-f7bd0c44]{text-align:center;margin-bottom:40px}.ad-300-250-sidebar-below[data-v-f7bd0c44]{text-align:center;margin-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f7bd0c44","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MostRecent.vue
// module id = 126
// module chunks = 0